import { render, staticRenderFns } from "./CollaborateForm.vue?vue&type=template&id=2ca2c458&"
import script from "./CollaborateForm.vue?vue&type=script&lang=js&"
export * from "./CollaborateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports